import { TableRouteField } from 'interfaces';

const getSortByCondition = (onSortBy: any, structure: Array<TableRouteField>) => {
  const id = onSortBy[0].id;
  const sortBy = structure.find((el) => el.id === id)?.sortBy || id;
  return `${sortBy}:${onSortBy[0].desc ? 'desc' : 'asc'}`;
};

export default getSortByCondition;
